/** A thrust (fx 'pierce', 'grab'): the point driven straight at the foe. */
import { registerFx } from './registry';

registerFx(['pierce', 'grab'], (host) => ({
  skill: ({ src, brk }) => {
    host.swingArc(src, 'thrust', brk ? '255,170,90' : '255,220,170');
    host.sfx.swing();
  },
}));
